/**
 * 文件流下载工具函数
 * @param {any} data - 接口返回的blob文件流
 * @param {string} type - 文件类型
 * @param {string} name - 文件名
 */
import { Message } from "element-ui";
export const downloadFile = (data, type, name, messageTip) => {
  const blob = new Blob([data], { type: type || "application/vnd.ms-excel" });
  const downloadElement = document.createElement("a");
  const href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  name = decodeURIComponent(escape(name));
  downloadElement.download = name;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
  Message({
    message: messageTip ? messageTip : "导出成功",
    type: "success"
  });
};
